import React, { useState} from 'react';
import './SignUpModal.css';
import { api } from '../services/api';
import Modal from './Modal';

function SignUpModal({ isOpen, onClose, onFacebookSignUp }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [verificationSent, setVerificationSent] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleEmailVerification = async (e) => {
    e.preventDefault();
    setError('');

    try {
      setSaving(true)
      await api.sendEmailVerification(email);
      setVerificationSent(true);
    } catch (err) {
      console.log("err: ", err.message)
      if (err?.response?.data?.error == "Email address already exists") {
        setError('Email is already in use');
      } else {
        setError('Failed to send email')
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      title="Create an Account"
      onClose={onClose}
    >
      <div className="signup-options">
        <div className="signup-section">
          <button className="signup-button facebook" onClick={onFacebookSignUp} disabled={saving || verificationSent}>
            Sign up with Facebook
          </button>
        </div>

        {/* <div className="divider">
          <span>or</span>
        </div>
        <div className="signup-section">
          {!verificationSent ? (
            <form onSubmit={handleEmailVerification}>
              <div className="form-group">
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError('');
                  }}
                  required
                  className={error ? 'error' : ''}
                />
                {error && <div className="error-message">{error}</div>}
              </div>
              <button type="submit" className="signup-button email continue-button" disabled={!email || saving || verificationSent}>
                Verify Email
              </button>
            </form>
          ) : (
            <div className="verification-sent">
              <p>Verification email sent to {email}. Please check your inbox and click the verification link to continue.</p>
            </div>
          )}
        </div> */}
      </div>
    </Modal>
  );
}

export default SignUpModal; 
// TODO FIX S3 BUILD PROCESS